import Api from "@/apis/Api";
import Csrf from "@/apis/Csrf";

//State
const state = {
  authenticated: false,
  user: null
};

//Getters
const getters= {

  authenticated (state) {
    return state.authenticated
  },

  user (state) {
    return state.user
  },
};

//Actions
const actions = {
  async signIn ({ dispatch }, credentials) {
    await Csrf.getCookie();
    await Api.post('/login', credentials)

    return dispatch('me')
  },

  async signOut ({ dispatch }) {
    await Api.post('/logout')

    return dispatch('me')
  },

  me ({ commit }) {
    return Api.get('/user').then((response) => {
      commit('SET_AUTHENTICATED', true)
      commit('SET_USER', response.data)
    }).catch(() => {
      commit('SET_AUTHENTICATED', false)
      commit('SET_USER', null)
    })
  }
};

//Mutations
const mutations = {
  SET_AUTHENTICATED (state, value) {
    state.authenticated = value
  },

  SET_USER (state, value) {
    state.user = value
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}